import { storeToRefs } from 'pinia'
import type { Composer } from 'vue-i18n'

export default defineNuxtPlugin((nuxtApp) => {
    if (import.meta.server) return

    const settingsStore = useSettingsStore()
    const { settings } = storeToRefs(settingsStore);

    const i18n = nuxtApp.$i18n as Composer
    const t = (key: string) => String(i18n.t(key))

    const loadChat = () => {
        if (document.querySelector('script[data-chat-widget="webixty-agent"]')) {
            return
        }

        const siteId = String(settings.value?.site_id)

        const script = document.createElement('script')

        script.src = 'https://cloud.webixty.com/chat/dist/embed.js'
        script.async = true
        script.defer = true

        script.dataset.chatWidget = 'webixty-agent'
        script.dataset.siteId = siteId
        script.dataset.language = i18n.locale.value || i18n.defaultLocale
        script.dataset.primaryColor = settings.value?.colors?.primary || '#010066'
        script.dataset.title = t('ai_title')
        script.dataset.subtitle = t('ai_subtitle')
        script.dataset.welcomeMessage = t('ai_welcome_message')
        script.dataset.placeholder = t('ai_placeholder')

        document.body.appendChild(script)
    }

    onNuxtReady(async () => {
        try {
            await settingsStore.loadPublic()
            if (settings.value?.ai_agent_enable) loadChat()
        } catch (error) {
            console.error('Chat loading failed:', error)
        }
    })
})
